import React from 'react';
import { TouchableOpacity, View, Text, StyleSheet, Image, Platform, Dimensions } from 'react-native';
import Colors from '../../constants/Colors';
import CS from '../../constants/Styles';
import Images from '../../constants/Images';
// import DistanceDisplay from '../DistanceDisplay';
// import { useNavigation } from '@react-navigation/native';
import { getCompanyLogoImageUrl } from '../../utils/Functions';
import { CachedImage } from '../../components';
import { useLinkTo } from '@react-navigation/native'

export default function ContractorPreview({...props}){
  const [imgStyle, setImgStyle] = React.useState({});
  // const navigation = useNavigation();
  const linkTo = useLinkTo();
  const windowWidth = Dimensions.get('window').width;

  React.useEffect(() => {
    setImgStyle(imgStyleWeb(windowWidth));

    if (Platform.OS === 'web') {
      const subscription = Dimensions.addEventListener('change', onChangeDimensions);
      return () => {
        subscription.remove();
        // Dimensions.removeEventListener('change', onChangeDimensions);
      }
    }
  }, []);

  const onChangeDimensions = ({ window, screen }) => {
    console.log('onChangeDimensions');
    setImgStyle(imgStyleWeb(window.width));
  };

  const imgStyleWeb = (windowWidth) => {
    if (Platform.OS === 'web') {
      const ratio = 540 / 960;
      let width = (windowWidth >= 768 ? 746 : (windowWidth - 22));
      console.log('logoStyle: ', width, width * ratio)
      return {
        width: width,
        height: width * ratio,
      }
    }
    return {};
  }

  const selectContractor = (contractor) => {
    console.log('selectContractor', contractor);
    linkTo(`/contractor/${contractor.company_id}`);
  }
  const defaultLogo = require('../../assets/img/blank_company_logo.jpg');

  // const imgStyleWeb = () => {
  //   if(Platform.OS === 'web'){
  //     return {
  //       width: 748,
  //       height: 421,
  //     }
  //   }
  //   return {
  //     aspectRatio: Images.company.logo.width / Images.company.logo.height //960/540
  //   }
  // }

  return (
    <TouchableOpacity onPress={() => selectContractor(props.contractor)}>
      <View style={styles.container}>
        {/* <Image source={{uri: props.contractor.logo}} style={{width:160, height: 38}} /> */}
        {/* <Image source={{ uri: props.contractor.logo }} style={[CS.responsiveImage, styles.logo]} /> */}
        {!props.contractor.logo &&
          <Image source={defaultLogo} style={[CS.responsiveImage, styles.logo, imgStyle]} />
        }
        {props.contractor.logo &&
          <CachedImage source={{ uri: getCompanyLogoImageUrl(props.contractor.company_id, props.contractor.logo) }} style={[CS.responsiveImage, styles.logo, imgStyle]} />
        }
        <View style={styles.infoContainer}>
          <View style={[CS.rowContainer, styles.mBottom3]}>
            <Text style={[CS.smallText, CS.lightText, CS.heavyText]}>{props.contractor.name}</Text>
            {/* <DistanceDisplay distance={props.contractor.distance} style={styles.distance} /> */}
          </View>
          <Text style={[CS.smallText, CS.lightText]}>{props.contractor.full_name}</Text>
        </View>
      </View>
    </TouchableOpacity>
  )
}

const styles = StyleSheet.create({
  container: {
    borderRadius: 5,
    borderStyle: 'solid',
    borderWidth: 1,
    borderColor: Colors.lightBlue2,
  },
  contractorName: {
    fontSize: 18,
    fontWeight: 'bold',
    color: Colors.lightText,
  },
  logo: {
    aspectRatio: 960 / 540,
    borderTopLeftRadius: 5,
    borderTopRightRadius: 5,
  },
  infoContainer: {
    padding:12,
    borderTopWidth: 1,
    borderColor: Colors.lightBlue2,
    backgroundColor: Colors.textInputBackground,
    borderBottomLeftRadius: 5,
    borderBottomRightRadius: 5,
  },
  distance: {
    marginLeft: 'auto',
  },
  mBottom3: {
    marginBottom: 3,
  }
});